<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-ai" />
      </v-card-title>
    </v-card>
    <dialogWindow
      ref="AlertAIClienSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.AlertAIClienSetup.dialog = false"
    >
    </dialogWindow>
    <dialogWindow
      ref="deleteAIClient"
      title="Delete AI Client"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['AI Client'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    >
    </dialogWindow>
  </div>
</template>
<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import $ from 'jquery';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    dialogWindow,
    IconSvg,
  },
  name: 'process-ai',
  props: {
    comId: {
      default: '',
    },
    refName: {
      default: '',
    },
    isAddConverter: {
      default: false,
    },
    comTp: {
      default: 'AI',
    },
    isHistory: {
      default: false,
    },
    aiTpCdList: {
      default: Array,
    },
    manage: {
      default: false,
    },
  },
  data() {
    return {
      procIconSize: 24,
      showClose: false,
      formData: {
        byProcSetup: true,
        aiId: '',
        aiNm: '',
      },
      checkDialogInfo: '',
      checkDialogColor: 'warning',
      hideItem: true,
      hideIcon: 'fa fa-caret-down',
      hideText: 'Expand',
      rulesComId: [],
      replacePatternData: {
        sender: '',
        receiver: '',
        message: '',
      },
      nodeId: '',
      numOfUse: 0,
      formEmit: {
        comTp: 'AI',
        comId: '',
        nodeId: '',
      },
    };
  },
  watch: {
    comId() {
      return this.comId;
    },
  },
  created() {
    this.initialize();
    EventBus.$on('updateFormData', this.updateFormData);
    EventBus.$on('change-component-data', this.changeComponentData);
  },
  destroyed() {
    EventBus.$on('updateFormData', this.updateFormData);
  },
  mounted() {},
  methods: {
    updateFormData(data) {
      if (this.nodeId === data.nodeInfo) this.resetForm();
      return;
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.formData.aiId = id;
        if (!this.formData.aiId) {
          this.resetForm();
          return;
        }
        this.selectAIClient();
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    initialize() {
      this.formData.aiId = this.comId;
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        if (this.formData.aiId !== '') {
          this.selectAIClient();
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
            aiTpCdList: this.aiTpCdList,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
    // 2021.6.14 203728 Reset form
    resetForm() {
      this.formData = {
        byProcSetup: true,
        aiId: '',
        aiNm: '',
        aiTp: '',
        listFormData: [],
        listHeader: [],
        aiEndpoint: '',
      };
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: this.comTp,
        aiTpCdList: this.aiTpCdList,
      };
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    selectAIClient() {
      const id = this.formData.aiId;
      let index = this.aiClientList.findIndex((e) => e.aiId == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.formData = Object.assign({}, this.aiClientList[index]);
        this.formEmit = {
          comId: this.formData.aiId,
          nodeId: this.nodeId,
          comName: this.formData.aiNm,
          comTp: this.comTp,
          aiTpCdList: this.aiTpCdList,
        };
        EventBus.$emit('set-comp-id', this.formEmit);
      } else {
        this.resetForm();
      }
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
  },
  computed: {
    aiClientList() {
      return this.$store.getters.aiClientSelectBoxList;
    },
  },
};
</script>
